import { useEffect } from 'react';
import { navigate, useQueryParams } from 'hookrouter';

const MortgageSignInPage = () => {
  const [queryParams] = useQueryParams();

  useEffect(() => {
    navigate('/sign-in', true, { appId: 'Mortgage', ...queryParams });
    window.scrollTo(0, 0);
  }, [queryParams]);
  return null;
};

export default MortgageSignInPage;
